import * as React from "react";
const SvgSearch = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path
      fill="#191919"
      fillRule="evenodd"
      d="M12.576 23.445a7.7 7.7 0 1 1 10.89-10.89 7.7 7.7 0 0 1-10.89 10.89m-1.131-12.021a9.3 9.3 0 0 0 12.562 13.694l5.469 5.469a.8.8 0 0 0 1.131-1.132l-5.468-5.469c3.08-3.654 2.9-9.12-.542-12.562a9.3 9.3 0 0 0-13.152 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSearch;
